import type {
  AdminProjectMember,
  AdminProjectSummary,
} from '@/versions/v1/shared/admin-seed';

const THREAD_COUNT_BY_PROJECT: Record<string, number> = {
  'proj-foundation': 24,
  'proj-onboarding': 11,
  'proj-research': 7,
};

const ASSIGNED_AT_BY_MEMBER: Record<string, number> = {
  'user-alex': Date.UTC(2026, 3, 1),
  'user-sam': Date.UTC(2026, 3, 12),
  'user-jordan': Date.UTC(2026, 4, 2),
  'user-riley': Date.UTC(2026, 4, 18),
  'user-taylor': Date.UTC(2026, 5, 6),
};

export function projectThreadCount(project: AdminProjectSummary): number {
  return THREAD_COUNT_BY_PROJECT[project.id] ?? project.memberCount * 3;
}

export function memberAssignedAt(member: AdminProjectMember): number {
  return ASSIGNED_AT_BY_MEMBER[member.userId] ?? Date.UTC(2026, 5, 1);
}

export function filterProjects(
  projects: AdminProjectSummary[],
  query: string,
): AdminProjectSummary[] {
  const needle = query.trim().toLowerCase();
  if (!needle) return projects;

  return projects.filter((project) => {
    const haystack = `${project.name} ${project.ownerEmail} ${project.ownerName ?? ''}`.toLowerCase();
    return haystack.includes(needle);
  });
}

export function roleLabel(
  role: AdminProjectMember['role'],
): 'Admin' | 'Member' | 'Viewer' {
  if (role === 'project_admin') return 'Admin';
  if (role === 'project_member') return 'Member';
  return 'Viewer';
}

export function rolePillTone(
  role: AdminProjectMember['role'],
): 'admin' | 'default' {
  return role === 'project_admin' ? 'admin' : 'default';
}
